<app-modal-header (closeModal)="close()"> </app-modal-header>
@defer (when isContentLoaded) {
  <app-modal-body>
    <div class="row sticky-top position-sticky bg-color-event">
      <div class="col-12">
        <h1 class="mb-2 fw-medium fs-20px">
          {{ (isHasAgendaInterest ? 'UPDATE_YOUR_INTERESTS' : 'TELL_USE_YOUR_INTERESTS') | translate }}
        </h1>
        <p class="mb-2 noto-sans fw-normal fs-16px">
          {{ 'AGENDA_RESELECT_TOPICS' | translate }}
        </p>
      </div>
      <div class="col-12">
        <div class="mb-3 mt-1">
          <input
            type="text"
            class="form-control mb-3 rounded-4"
            placeholder="{{ 'SEARCH' | translate }}"
            [(ngModel)]="searchTerm"
            (ngModelChange)="onSearchChange()"
          />
        </div>
      </div>
    </div>
    <div class="mt-3">
      <ul class="list-group text-break">
        @for (item of filteredList; track $index; let i = $index) {
          <li
            class="list-group-item d-flex justify-content-between align-items-center noto-sans fw-normal fs-14px"
            tabindex="0"
            role="button"
            (click)="selectFilter(item)"
          >
            {{ item?.value }}
            @if (isSelected(item)) {
              <i class="ri-check-fill"></i>
            }
          </li>
        }
      </ul>
    </div>
  </app-modal-body>
  <app-modal-footer>
    <div class="d-flex justify-content-center w-100">
      <button type="button" class="btn btn-primary rounded-5 fw-medium" (click)="update()">
        {{ (selected.length > 0 ? 'UPDATE' : 'SAVE') | translate }}
      </button>
    </div>
    @if (validationMessage) {
      <div class="d-flex justify-content-center w-100">
        <span class="text-danger fs-16px mt-2">{{ validationMessage | translate }}</span>
      </div>
    }
  </app-modal-footer>
} @placeholder {
  <app-modal-body>
    <div class="d-flex flex-column justify-content-center">
      @for (item of [1, 2, 3, 4, 5, 6, 7, 8, 9]; track $index) {
        <ngx-skeleton-loader
          count="1"
          [theme]="{ width: '100%', marginTop: '12px', height: '100px', borderRadius: '8px', marginBottom: 0 }"
        />
      }
    </div>
  </app-modal-body>
}
